/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';
import { connect } from 'react-redux';
import { FormDetails, getFormDetails } from '../form-details-reducer';
import styles, { StyledComponent } from '../../../../../styles/styles';
import { Grid, Paper, Typography, withStyles } from '@material-ui/core';
import { LabeledValue } from '../../../../../controls/labeled-value';
import { State } from '../../../../../redux/root-reducer';

interface BaseProps {
    formDetails?: FormDetails;
}

interface Props extends BaseProps, StyledComponent {}

const permanentImpairmentClaimsView: React.FC<Props> = ({ classes, formDetails }: Props) => {
    const guaranteedPaymentPeriodClaims = formDetails?.claimInformation?.permanentImpairmentClaims;
    return (
        <>
            <Grid container justify="space-between" className={classes.marginTop2}>
                <Grid container item xs={10} alignItems="center">
                    <Typography style={{ padding: 10 }} className={classes.heading} variant="body1">
                        Permanent Impairment Claims
                    </Typography>
                </Grid>
            </Grid>

            <Paper className={classes.paper}>
                <Grid item xs={12} lg={12}>
                    <LabeledValue label="Please mark all the relevant categories you are claiming for (OPTIONAL)" />
                </Grid>
                <Grid container spacing={2} className={classes.marginTop2}>
                    {guaranteedPaymentPeriodClaims?.map((permanentOptions: any, index: number) => (
                        <Grid item xs={4} lg={3} key={index}>
                            <Typography>{permanentOptions}</Typography>
                        </Grid>
                    ))}
                </Grid>
            </Paper>
        </>
    );
};

const mapStateToProps = (state: State, ownProps: BaseProps) => ({
    formDetails: ownProps.formDetails ?? getFormDetails(state),
});

const mapDispatchToProps = {};

export const PermanentImpairmentClaimsView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(permanentImpairmentClaimsView));
